import { endPoints } from 'api/endpoints';
import axios from 'api/request';

const fetchMemberData = async (gpid) => {
    const response = await axios.get(`${endPoints.appProfile.appOwner}?key=${gpid}`);
    return response.data;
};

export const fetchAllAdGroupMembers = async (members) => {
    const memberPromises = members.map(fetchMemberData);
    const results = await Promise.all(memberPromises);

    return results
        .map((result) => {
            const memberData = result?.[0];
            if (!memberData) return null;
            return {
                label: `${memberData?.gpid} - ${memberData?.name}`,
                gpid: memberData?.gpid,
                name: memberData?.name,
                email: memberData?.email,
            };
        })
        .filter(Boolean); // Remove any null entries
};

export default fetchAllAdGroupMembers;
